import {CUSTOMERS_V2} from '../common/endpoints';
import {toCreateCustomerGuidRequest, toUpdateCustomerGuidRequest} from '../mappers/customerGuid.mapper';
import {CustomerGuidFields, CustomerGuidSearchParams, CustomerGuidSearchResponse, ICustomerGuid} from '@mybake/ui/models/Customers/ICustomerGuid';
import {baseAPI} from './BaseAPI';

export const customerAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({

        getCustomersV2: build.query<CustomerGuidSearchResponse, CustomerGuidSearchParams>({
            query: (params) => ({
                url: CUSTOMERS_V2,
                method: 'GET',
                params,
            }),

            providesTags: (result) => ['Customers'],
        }),

        getCustomerByIdV2: build.query<ICustomerGuid, string>({
            query: (id) => ({
                url: `${CUSTOMERS_V2}/${id}`,
                method: 'GET',
            }),

            providesTags: (result, error, id) => [{type: 'Customers', id}],
        }),
        searchCustomersV2: build.mutation<ICustomerGuid[], {search: string}>({
            query: body => ({
                url: `${CUSTOMERS_V2}/search`,
                method: 'POST',
                body,
            }),
        }),

        updateCustomerV2: build.mutation<ICustomerGuid, {id: string; customer: ICustomerGuid}>({
            query: ({id, customer}) => ({
                url: `${CUSTOMERS_V2}/${id}`,
                method: 'PUT',
                body: toUpdateCustomerGuidRequest(customer),
            }),

            invalidatesTags: (result) => ['Customers'],
        }),

        deleteCustomerV2: build.mutation<ICustomerGuid, string>({
            query: (id) => ({
                url: `${CUSTOMERS_V2}/${id}`,
                method: 'DELETE',
            }),

            invalidatesTags: ['Customers'],
        }),
        createCustomerV2: build.mutation<ICustomerGuid, CustomerGuidFields>({
            query: (customer) => ({
                url: CUSTOMERS_V2,
                method: 'POST',
                body: toCreateCustomerGuidRequest(customer),
            }),
            invalidatesTags: ['Customers'],
        }),
    }),
});
